import {
  ISearchSuggestionResponseKeys,
  ISuggestionEntry,
  ITypedSuggestionEntry,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import {
  getContainerName,
  getSuggestionEventToken,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/utils";
import { isNotUndefined } from "@faire/typescript";
import { trackSearchSuggestionsView } from "@faire/web-api--source/events/search/view/suggestions";
import { useStrictLocalization } from "@faire/web/common/localization/localize";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import * as React from "react";

type Props = {
  sectionHeader: string;
  suggestionArray:
    | ISuggestionEntry[]
    | ITypedSuggestionEntry<ISearchSuggestionResponseKeys>[];
  sectionIndex: number;
  query: string;
};

export const ResultsDropdownSectionWrapper: React.FC<
  React.PropsWithChildren<Props>
> = ({ children, sectionHeader, suggestionArray, sectionIndex, query }) => {
  const { strictLocalize } = useStrictLocalization();

  const trackView = React.useCallback(
    (
      sectionHeader: string,
      suggestionArray:
        | ISuggestionEntry[]
        | ITypedSuggestionEntry<ISearchSuggestionResponseKeys>[],
      sectionIndex: number
    ): void => {
      const requestId = suggestionArray[0]?.requestID;

      const containerName = getContainerName(sectionHeader, strictLocalize);
      const suggestionEventTokenArray = suggestionArray
        .map((suggestion) => {
          return getSuggestionEventToken(
            sectionHeader,
            suggestion,
            strictLocalize
          );
        })
        .filter(isNotUndefined);

      if (suggestionEventTokenArray.length > 0) {
        const token = `${query}|${suggestionEventTokenArray.join("|")}`;

        trackSearchSuggestionsView(
          `${containerName}|${sectionIndex}`,
          requestId ?? "",
          token
        );
      }
    },
    [query, strictLocalize]
  );

  const ref = useDoActionWhenVisible(() => {
    trackView(sectionHeader, suggestionArray, sectionIndex);
  });

  return (
    <ul data-test-id={sectionHeader.toLowerCase().replace(" ", "-")} ref={ref}>
      {children}
    </ul>
  );
};
